import { DbMode } from './denthub-settings';

export type DataSet = 'REGRESSION' | 'PRODUCTION_COPY';

export type DataSetSummary = {
    dataSet: DataSet;
    available: boolean;
    snapshotDate?: string | null;
};

export type DataSetSwitchState = 'RUNNING' | 'DONE' | 'FAILED' | 'INTERRUPTED';

export type DataSetSwitchStep = 'PREPARING' | 'DROPPING' | 'COPYING' | 'INDEXING' | 'FINISHING';

export type DataSetSwitchStatus = {
    state: DataSetSwitchState;
    dataSet: DataSet;
    step: DataSetSwitchStep;
    copiedDocuments: number;
    totalDocuments: number;
    copiedCollections: number;
    totalCollections: number;
    currentCollection?: string | null;
    startedAt: string;
    finishedAt?: string | null;
    startedBy: string;
    error?: string | null;
};

export const DATA_SET_BY_DB_MODE: Partial<Record<DbMode, DataSet>> = {
    test: 'REGRESSION',
    prodCopy: 'PRODUCTION_COPY',
};
